// @ts-ignore
import { InkCanvas2D } from "digital-ink";

import { BasicInkController } from "./BasicInkController";

export class Inking2DSample extends BasicInkController {
	tool = "app://ink-samples/toolkit/Pen";
	constructor(canvas) {
		super(InkCanvas2D.createInstance(canvas));
		// super(InkCanvasGL.createInstance(canvas));
	}

	/**
	 * ツールを設定します
	 * @param toolName ツール名（例："app://ink-samples/toolkit/Pen", "app://ink-samples/toolkit/PartialStrokeEraser"）
	 */
	setTool(toolName) {
		this.tool = toolName;
	}
}
